'use strict';

export default class AlertMessages extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {

        this._shadowRoot = this.attachShadow({mode: 'open'});
        this.message = JSON.parse(this.getAttribute('alertMessage'));

        const alertMessagesTemplate = document.querySelector('#alert-messages-template');
        const spacer = this.hasAttribute('spacer');
        const alertMessagesInstance = alertMessagesTemplate.content.cloneNode(true);
        const messageContent = alertMessagesInstance.querySelector('[name="alert-messages-container"]');
        const alerts = ['danger', 'warning', 'success', 'info-light', 'info'];

        if (!this.message) {
            return;
        }

        let messageIcon = this.message.icon;

        if (this.message.image) {
            let imageElement = document.createElement('img');
            imageElement.src = this.message.image;
            messageContent.querySelector('.alert-message-button-container').appendChild(imageElement);
        }

        if (this.message.closeAlert) {
            messageContent.querySelector('.alert-messages-container').classList.add('alert-close')
            messageContent.querySelector('.close-icon-container').addEventListener("click", (event) => {
                this.remove();
            });
        }

        if (this.message.status) {
            if (alerts.includes(this.message.status)) {
                if (!this.message.icon) {
                    messageIcon = 'ci-info';
                }
                if (this.message.header) {
                    messageContent.querySelector('slot[name="header-content"]').innerHTML = this.message.header;
                }
                messageContent.querySelector('slot[name="text-content"]').innerHTML = this.message.text;
                messageContent.querySelector('.message-label').remove();
                messageContent.querySelector('.message-mobile').remove();
                messageContent.querySelector('[name="status"]').remove();
                if (spacer) {
                    messageContent.querySelector('[name="spacer"]').classList.add("service-spacer");
                }

                if (this.message.tpvDontExit) {
                    messageContent.querySelector('.alert-messages-container').classList.add("tpv-dont-exit");
                }
                messageContent.querySelector('.alert-messages-container').classList.add("alert", this.message.status);
            } else {
                messageContent.querySelector('.message-label').classList.add(this.message.status);
                messageContent.querySelector('.message-mobile').classList.add(this.message.status);
                if (this.message.class) {
                    messageContent.querySelector('.alert-messages-container').classList.add(this.message.class);
                }
                if (this.message.wordMessage) {
                    messageContent.querySelector('.message-word').innerHTML = this.message.wordMessage;
                    messageContent.querySelector('.message-mobile').innerHTML = this.message.wordMessage;
                }

                messageContent.querySelector('[name="status"]').classList.add(this.message.status);
                if (spacer) {
                    messageContent.querySelector('[name="spacer"]').classList.add("service-spacer");
                }
            }
        }

        if (this.message.classes) {
            let messagesContainer = messageContent.querySelector('.alert-messages-container');

            for (let messageClass of this.message.classes) {
                messagesContainer.classList.add(messageClass);
            }
        }

        messageContent.querySelector('.ci').classList.add(messageIcon, 'ci-s-20');
        messageContent.querySelector('[name="alert-message-button"]').classList.add(
            this.getAttribute('alert-message-button-bgcolor')
        );
        alertMessagesInstance.querySelector('[name="stylesheet"]').href = this.getAttribute('stylesheet');

        this._shadowRoot.appendChild(alertMessagesInstance);
        return this._shadowRoot;
    }

    buildCloseContainerClick(onClickFunction) {
        this._shadowRoot.querySelector('.close-icon-container').addEventListener("click", (event) => {
            onClickFunction();
            event.stopPropagation();
            event.stopImmediatePropagation();
        });
    }
}
